import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import { loadCompanions } from "../state/companionSlice";
import axios from "axios";
import { PostAlert } from "./AlertActions";
import { Logout } from "./LoginActions";
import * as Globals from "../Globals";
export function GetCompanionList(dispatch) {
  axios.get(`${Globals.baseUrl}/Companion/GetCompanionSchemas`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CompanionList,
        Result: res.data
      });
      if (dispatch != null) {
        dispatch(loadCompanions(res.data));
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetAvailCompTables(callback) {
  axios.get(
    `${Globals.baseUrl}/Companion/GetCompanionDBTables`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      callback(res.data);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function GetAvailCompColumns(tableName, callback) {
  axios.get(
    `${Globals.baseUrl}/Companion/GetCompanionDBColumns/${tableName}`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      callback(res.data);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function CreateCompanion(comp, dispatch, callback) {
  axios.post(
    `${Globals.baseUrl}/Companion/CreateCompanionSchema`,
    comp,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      callback();
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function UpdateCompanion(comp, dispatch, callback) {
  axios.post(
    `${Globals.baseUrl}/Companion/UpdateCompanionSchema`,
    comp,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      callback();
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function LoadCompanionSchema(id, callback) {
  axios.post(
    `${Globals.baseUrl}/Companion/GetSchema`,
    { compId: id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CompanionLoadOne,
        Result: res.data
      });
      if (callback) {
        callback(res.data);
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
export function GetCompanionData(id, callback, schema) {
  axios.post(
    `${Globals.baseUrl}/Companion/GetData`,
    { compId: id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.CompanionGetData,
        Result: res.data
      });
      if (callback) {
        callback(res.data, schema);
      }
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateCompanionData(id, data) {
  axios.post(
    `${Globals.baseUrl}/Companion/UpdateData`,
    { schemaId: id, data },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      if (res.data.status === "Success") {
        PostAlert("success", res.data.updateMessage);
      } else {
        PostAlert("error", res.data.updateMessage);
      }
      GetCompanionData(id);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("error");
  });
}
